/**
 * Abrir el drawer de supportIA desde cualquier página (el Home, la subtab
 * Asistente de TA…), opcionalmente con una pregunta ya cargada. El layout
 * (DashboardLayout) escucha el evento; el modo del drawer (general, hub de un
 * partner, Agente TA Metrics) lo decide el contexto de la página, no acá.
 */
export const OPEN_ASSISTANT_EVENT = 'internal:open-assistant';

export interface OpenAssistantDetail {
  question?: string;
}

export function openAssistant(question?: string): void {
  const detail: OpenAssistantDetail | undefined = question ? { question } : undefined;
  window.dispatchEvent(new CustomEvent<OpenAssistantDetail | undefined>(OPEN_ASSISTANT_EVENT, { detail }));
}
